import { useStore } from 'effector-react'
import {
  $budgetItem,
  budgetItemMounted,
  getBudgetItem,
  sectionListForSelectMounted,
} from './model'
import { useLayoutEffect } from 'react'
import { $sectionList } from '../../sections/list/model'

export const useEditBudgetItem = () => {
  const budgetItem = useStore($budgetItem)
  const section = useStore($sectionList)

  const loadingBudgetItem = useStore(getBudgetItem.pending)

  useLayoutEffect(() => {
    budgetItemMounted()
    sectionListForSelectMounted()
  }, [])

  return { budgetItem, section, loadingBudgetItem }
}
